import styled from "styled-components";

export const Styles = styled.div`
  --cell-vertical-spacing: 4px;
  .input-field {
    padding: 0px 2px;
    width: 100%;
    height: calc(100% - var(--cell-vertical-spacing));
    outline: none;
    border: 1px solid #ccc;
  }
  .has-error {
    .input-field {
      border: 1px solid var(--error-border);
      background: var(--error-bg);
    }

    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
      border: 1px solid var(--error-border) !important;
      background: var(--error-bg) !important;
      box-shadow: none;
    }
  }

  &.is-in-edit-mode {
    .ag-cell {
      padding: 0 4px;
    }
  }
`;
